export const fetcher = async (path: string): Promise<any> => {
	const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');
	const isCookieMode = process.env.REACT_APP_AUTH_IN_COOKIE === '1';

	const url = `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;

	const headers: Record<string, string> = {
		'Content-Type': 'application/json',
	};


	// Include Authorization header only when not in cookie mode
	if (!isCookieMode && typeof window !== 'undefined') {
		const token = localStorage.getItem('token');
		if (token) headers['Authorization'] = `Bearer ${token}`;
	}

	const res = await fetch(url, {
		headers,
		credentials: 'include',
	});

	if (!res.ok) {
		let message = `${res.status} ${res.statusText}`;
		try {
			const data = await res.json();
			if (data?.error?.message) message = data.error.message;
			else if (data?.error) message = typeof data.error === 'string' ? data.error : JSON.stringify(data.error);
		} catch (_) {}
		throw new Error(message);
	}

	try {
		return await res.json();
	} catch {
		return null;
	}
}; 